/**
 * Map the page type to the template
 * @param  {String} options.pageType Page type
 * @param  {String} options.platform  web view platform
 * @param  {String} options.sport    Sport
 * @return {String|undefined} Handlebars template name
 */
export function mapPageToTemplate({ pageType, sport, platform = '' }) {
  const webview = platform ? '-webview' + '-' + platform : ''
  const map = {
    scores: 'scoreboard',
    scoreboard: 'scoreboard',
    team: 'clubhouse',
    standings: 'standings',
    table: 'standings',
    game: 'gamepackage',
    scorecard: 'gamepackage',
    recap: 'gamepackage',
    report: 'gamepackage',
    preview: 'gamepackage',
    commentary: 'gamepackage',
    statistics: 'gamepackage',
    coverage: 'gamepackage',
    video: 'gamepackage',
    lineups: 'gamepackage',
    matchstats: 'gamepackage',
    playerstats: 'gamepackage',
    conversation: 'gamepackage',
    match: 'gamepackage',
    hawkeye: 'gamepackage',
    fixtures: 'schedule',
    results: 'schedule',
    schedule: 'schedule',
    // Example: when standings are called tables
    // or scoreboard is called scores
    cricket: {
      match: 'gamepackage',
      table: 'standings'
    }
  }
  const template = map[sport] && map[sport][pageType] || map[pageType]
  return template ? template + webview : undefined
}

export default mapPageToTemplate



// WEBPACK FOOTER //
// ./lib/mapPageToTemplate.js